import { apiSlice } from '../../../store/api/apiSlice';

export interface ImpersonateRequest {
  target_person_id: string;
}

export interface ImpersonateTarget {
  id: string;
  name: string;
  email: string;
  org_id: string;
  given_name: string;
  family_name: string;
  roles: string[];
  permissions: string[];
}

export interface ImpersonateResponse {
  access_token: string;
  target: ImpersonateTarget;
  expires_at: string;
}

export const impersonationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Start impersonation session
    startImpersonation: builder.mutation<ImpersonateResponse, ImpersonateRequest>({
      query: (body) => ({
        url: '/admin/impersonate',
        method: 'POST',
        body,
      }),
    }),

    // End impersonation session
    endImpersonation: builder.mutation<{ ok: boolean }, void>({
      query: () => ({
        url: '/admin/impersonate/end',
        method: 'POST',
      }),
    }),
  }),
});

export const { useStartImpersonationMutation, useEndImpersonationMutation } = impersonationApi;
